module.exports = "<footer class=\"app-footer\">\r\n    <span>\r\n        terGIS v {{ appVersion }}\r\n      </span>\r\n</footer>\r\n"